export default __webpack_public_path__ + "static/media/affected.2bf4175f.svg";